export default {
  All: 'all',
  IncludeItemsAssociatedWithAsset: 'includeItemsAssociatedWithAsset',
  IncludeItemsNotAssociatedWithAsset: 'includeItemsNotAssociatedWithAsset',
}
